import { render, staticRenderFns } from "./TaskEditDialog.vue?vue&type=template&id=3ad4a810&scoped=true"
import script from "./TaskEditDialog.vue?vue&type=script&lang=js"
export * from "./TaskEditDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskEditDialog.vue?vue&type=style&index=0&id=3ad4a810&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4a810",
  null
  
)

export default component.exports